
import {
  Component, Mixins, Watch,
} from 'vue-property-decorator';
import { State } from 'vuex-class';
import { PlatformType } from '@/store/directory/types';
import LoadingDataMixin from '@/mixins/LoadingDataMixin';
import { TypeExtractionRules } from '@/classes/schema-constructors/types';
import UserMixin from '@/mixins/UserMixin';

@Component
export default class PlatformsAndSuppliersMixin extends Mixins(LoadingDataMixin, UserMixin) {
  @State('platforms', { namespace: 'directory' })
  readonly platforms!: PlatformType[];

  @State('platformsIsLoading', { namespace: 'directory' })
  readonly platformsIsLoading!: boolean;

  suppliers = [];

  suppliersIsLoading = false;

  selectedPlatform = '';

  loadSuppliers(rules?: TypeExtractionRules) {
    return this.loadDataByLike('suppliers', 'Supplier', 'PlantsHR', this.selectedPlatform, 'cache-first', rules);
  }

  setSelectedPlatform() {
    let selectedPlatform = '';
    if (typeof window !== 'undefined') {
      selectedPlatform = this.getFromStorage('selected_platform');
    }
    if (Number(selectedPlatform)) {
      this.selectedPlatform = selectedPlatform;
    } else {
      this.selectedPlatform = this.userPlatforms[0]?.id || '';
    }
  }

  afterLoadingPlatforms() {
    console.log('platforms loaded');
  }

  async beforeLoadSuppliers() {
    console.log('before load suppliers');
  }

  afterLoadSuppliers() {
    console.log('after load suppliers');
  }

  @Watch('selectedPlatform')
  async selectedPlatformChanged(value: string, oldValue: string | undefined) {
    if (value && oldValue) {
      await this.beforeLoadSuppliers();
      if (typeof window !== 'undefined') {
        this.setToStorage('selected_platform', value);
      }
      await this.loadSuppliers({ maxDepth: 1 });
      this.afterLoadSuppliers();
    }
  }

  @Watch('platformsIsLoading', {
    immediate: true,
  })
  async platformsIsLoadingChanged(value: string) {
    if (!value) {
      this.setSelectedPlatform();
      if (this.selectedPlatform) {
        await this.loadSuppliers({ maxDepth: 1 });
      }
      this.afterLoadingPlatforms();
    }
  }
}
